import {
  BatchReminderListConditionListItem,
  BatchReminderListConditionListItemFromJSON
} from '@/api/models/batch/BatchReminderListConditionListItem'

export interface BatchReminderListPageLoadResult {
  items: BatchReminderListConditionListItem
}

export function BatchReminderListPageLoadResultFromJSON(
  json: any
): BatchReminderListPageLoadResult {
  return {
    items: BatchReminderListConditionListItemFromJSON(json)
  }
}
